import { useState } from 'react';

export const useCallAnimation = ({ clickAnimation }) => {
  const [classes, setClasses] = useState([]);

  return {
    callAnimation() {
      if (!clickAnimation || classes.some(({ animationName }) => animationName === clickAnimation.animationName))
        return;

      const { animationName, className } = clickAnimation;

      setClasses((prev) => [...prev, { animationName, className }]);
    },
    onAnimationEnd({ animationName } = {}) {
      if (clickAnimation)
        setClasses((prev) => prev.filter((animationData) => animationData.animationName !== animationName));
    },
    classes: classes.map(({ className }) => className),
  };
};
